function wowo($) {
  setTimeout(function () {
    jQuery("html").addClass("show-c");
    var wTop = jQuery(window).scrollTop(),
      wHeight = jQuery(window).height(),
      wBottom = wTop + wHeight;
    jQuery(".wowo:not(.animated)").each(function () {
      var me = jQuery(this),
        meTop = me.offset().top,
        meHeight = me.height(),
        meBottom = meTop + meHeight,
        limitTop = wTop - meHeight,
        limitBottom = wBottom + meHeight;
      if (meTop > limitTop && meBottom < limitBottom) {
        me.addClass("animated");

        setTimeout(function () {
          //me.removeClass("animated wowo");
        }, 1500);
      }
    });

    jQuery(".paralax-insta:not(.animated)").each(function () {
      var me = jQuery(this),
        meTop = me.offset().top,
        meHeight = me.height(),
        meBottom = meTop + meHeight,
        limitTop = wTop - meHeight,
        limitBottom = wBottom + meHeight;

      if (meTop > limitTop && meBottom < limitBottom) {
        for (var i = 1; i <= 8; i++) {
          me.find(".paralax__image.image-" + i).addClass(" animated myAnimation_" + i);
        }
        for (var i = 1; i <= 10; i++) {
          me.find(".paralax__title.title-" + i).addClass(" animated titleAnimation_" + i);
        }
        me.find(".paralax__image-logo.image-7").addClass(" animated myAnimation_7");
        me.find(".paralax__image-logo.image-8").addClass(" animated myAnimation_8");
        setTimeout(function () {
          // me.removeClass("animated wowo");
        }, 5000);
      }
    });
  }, 100);
}

function scroll() {
  var $header = jQuery(".header");
  var $topBar = $(".header-top-bar");
  var hasTopBar = $topBar.length > 0;
  
  var lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
  var headerHeight = $header.innerHeight();
  var barHeight = hasTopBar ? $topBar.innerHeight() : 0;

  function handleScroll() {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var scrollDirection = scrollTop - lastScrollTop;
    lastScrollTop = scrollTop;

    if (scrollTop > headerHeight) {
      $header.addClass("sticky bg-light");
      
      if (hasTopBar && !$topBar.hasClass("flag")) {
        $topBar.css("margin-top", -barHeight);
        
        if (scrollDirection > 0) {
          $header.addClass("sticky");
        } else {
          $header.removeClass("sticky");
          $topBar.css("margin-top", "0");
        }
      }
    } 
    else {
      $header.removeClass("sticky bg-light");
      if (hasTopBar && !$topBar.hasClass("flag")) {
        $topBar.css("margin-top", "0");
      }
    }
  }

  handleScroll();

  jQuery(window).on("scroll", handleScroll);

  if (hasTopBar) {
    $(".header-top-bar .icon-close").on("click", function() {
      $topBar.addClass("flag").css("margin-top", -barHeight);
    });
  }
}
function cookie() {
  if (jQuery(".pop-up").length > 0) {
    if (jQuery.cookie("open-pop-up")) {
      jQuery(".pop-up").fadeOut();
      $("html,body").removeClass("overflow-hidden");
    } else {
      jQuery(".pop-up").fadeIn();
      $("html,body").addClass("overflow-hidden");
    }
    jQuery.cookie("open-pop-up", "pop-up", {
      expires: 1,
      path: "/",
    });
  }

  if (jQuery(".bottom-pop-up").length > 0) {
    if (jQuery.cookie("bottom-pop-up")) {
      jQuery(".bottom-pop-up").fadeOut();
    } else {
      jQuery(".bottom-pop-up").fadeIn();
    }
    jQuery.cookie("bottom-pop-up", "bottom-pop-up", {
      expires: 1,
      path: "/",
    });
  }
  $(".bottom-pop-up .icon-close").click(function () {
    jQuery(".bottom-pop-up").fadeOut();
    $("html,body").removeClass("overflow-hidden");
  });

  $(".bottom-pop-up .btn-black").click(function () {
    jQuery(".bottom-pop-up").fadeOut();
    $("html,body").removeClass("overflow-hidden");
  });
}

function video() {
  jQuery(".video-link.mp4,.is-video").click(function (event) {
    event.preventDefault();
    jQuery(document).bind("mousewheel DOMMouseScroll", function (event) {
      event.preventDefault();
    });
    jQuery(document).bind("touchmove", function (event) {
      event.preventDefault();
    });

    var video_url = jQuery(this).find(".data-video").html();
    jQuery(".video-light-box")
      .find(".play-iframe-video")
      .append('<video  muted loop="loop" controls="controls"><source src="' + video_url + '" type="video/mp4"></video>');
    jQuery(".video-light-box").fadeIn(300);

    var videoElements = jQuery(".video-light-box video");
    var hls = new Hls();
    videoElements.each(function () {
      var videoSrc = jQuery(this).find("source").attr("src");
      var videoElement = this;
      if (videoSrc.endsWith(".mp4")) {
      } else {
        hls.loadSource(videoSrc);
        hls.attachMedia(videoElement);
      }
    });
  });
  jQuery(".video-link.file").click(function (event) {
    event.preventDefault();
    jQuery(document).bind("mousewheel DOMMouseScroll", function (event) {
      event.preventDefault();
    });
    jQuery(document).bind("touchmove", function (event) {
      event.preventDefault();
    });
    var video_url = jQuery(this).find(".data-video").html();
    var caption = jQuery(this).find(".data-video").attr("data-caption");
    jQuery(".video-light-box")
      .find(".play-iframe-video")
      .append('<video controls="controls"><source src="' + video_url + '" type="video/mp4"> <track src="' + caption + '"  srclang="en" label="English" kind="subtitles" default /></video>');
    jQuery(".video-light-box").fadeIn(300);
  });
  jQuery(".video-link.embed").click(function (event) {
    event.preventDefault();
    jQuery(document).bind("mousewheel DOMMouseScroll", function (event) {
      event.preventDefault();
    });
    jQuery(document).bind("touchmove", function (event) {
      event.preventDefault();
    });
    jQuery(".video-light-box").fadeIn(300);
    var html = jQuery(this).find(".data-video").html();
    console.log(html);
    jQuery(".video-light-box").find(".play-iframe-video").html(html);
  });

  jQuery(".video-light-box .icon-close").click(function () {
    jQuery(document).unbind("mousewheel DOMMouseScroll");
    jQuery(document).unbind("touchmove");
    jQuery(".video-light-box").fadeOut(300);
    setTimeout(function () {
      jQuery(".video-light-box").find(".play-iframe-video").html("");
    }, 300);
  });

  jQuery(".video-light-box").click(function () {
    jQuery(document).unbind("mousewheel DOMMouseScroll");
    jQuery(document).unbind("touchmove");
    jQuery(".video-light-box").fadeOut(300);
    setTimeout(function () {
      jQuery(".video-light-box").find(".play-iframe-video").html("");
    }, 300);
  });
  jQuery(".video-light-box .video-box").click(function (event) {
    event.stopPropagation();
  });

  jQuery(".video-link,.is-video").click(function (event) {
    event.stopPropagation();
    var vvv = jQuery(this).children(".video").find("video");
    vvv.on("loadedmetadata", function () {
      vvv.trigger("play");
    });
    // vvv.trigger('play');

    setTimeout(function () {
      var ss = jQuery(".video-light-box .video-box video");
      ss.trigger("play");
    }, 300);
  });

  jQuery(".video-show").click(function (event) {
    event.stopPropagation();
    jQuery(this).children(".text-and-img").addClass("is-active");
    var vvv = jQuery(this).parents(".video").find("video");

    if (jQuery(this).hasClass("is-active")) {
      vvv.trigger("play");
      jQuery(this).removeClass("is-active");
    } else {
      jQuery(this).addClass("is-active");
      vvv.trigger("pause");
    }
  });
}

function addClass() {
  jQuery("a").attr("tabindex", "0");
  jQuery('a[href="#"]').click(function (event) {
    event.preventDefault();
  });
}
function hlsVideo() {
  // var videoElements = document.querySelectorAll("video");

  var videoElements = document.querySelectorAll("video");

  videoElements.forEach(function (videoElement) {
    var videoSrc = videoElement.getAttribute("src");

    if (videoSrc && videoSrc.endsWith(".mp4")) {
    } else {
      var hls = new Hls();
      hls.loadSource(videoSrc);
      hls.attachMedia(videoElement);
    }
  });
}

function insta() {
  if (jQuery("#instafeed").length > 0) {
    var InstagramToken = $("#instafeed").attr("data-key");
    var link = $("#instafeed").attr("data-link");
    var feed = new Instafeed({
      accessToken: InstagramToken,
      limit: 6,
      template: '<div class="paralax__image ">  <div style="background-image:  url({{image}})"></div></div>',
      after: function () {
        jQuery(".paralax__image").each(function () {
          var i = jQuery(this).index() + 1;
          jQuery(this).addClass(" image-" + i + "");
        });

        wowo();
      
      },
    });
    feed.run();
  }
}

function cartInput() {
  if (jQuery(".cart-and-details").length > 0) {
    jQuery(".cart-and-details .form__details input,.form__details textarea").val("");
    jQuery(".cart-and-details .form__collect input").val("");
    jQuery('.cart-and-details .form__details input[type="radio"]').prop("checked", false);
    jQuery(".cart__footer  .cart__ctas .btn").attr("disabled", "disabled");

    jQuery(".cart__dynamic-checkout-buttons ").addClass("hidden-c");

    jQuery("input").change(function () {
      if (!jQuery(".form__details").hasClass("hidden")) {
        var FullName = jQuery(' .form__details input[name="attributes[Your Full Name]"]').val();
        var phoneNumber = jQuery('.form__details input[name="attributes[Your Phone Number]').val();

        var deliveryDate = jQuery('.form__details input[name="attributes[Delivery date]"]').val();

        // var deliveryBusinessName = jQuery('input[name="attributes[Delivery Business Name]"]').val();
        // var deliveryAddress = jQuery('input[name="attributes[Delivery Address]"]').val();
        // var radioValue = jQuery('input[type="radio"]').is(":checked");

        if (FullName && phoneNumber && deliveryDate) {
          jQuery(".cart__footer .cart__ctas .btn").removeAttr("disabled");
          jQuery(".cart__dynamic-checkout-buttons ").removeClass("hidden-c");
        } else {
          jQuery(".cart__footer .cart__ctas .btn").attr("disabled", "disabled");
          jQuery(".cart__dynamic-checkout-buttons ").addClass("hidden-c");
        }
      } else {
        var FullName = jQuery('.form__collect input[name="attributes[Your Full Name]"]').val();
        var phoneNumber = jQuery('.form__collect input[name="attributes[Your Phone Number]"]').val();
        var collectionDate = jQuery('.form__collect input[name="attributes[Collection Date]').val();

        if (FullName && phoneNumber && collectionDate) {
          jQuery(".cart__footer .cart__ctas .btn").removeAttr("disabled");
          jQuery(".cart__dynamic-checkout-buttons ").removeClass("hidden-c");
        } else {
          jQuery(".cart__footer .cart__ctas .btn").attr("disabled", "disabled");
          jQuery(".cart__dynamic-checkout-buttons ").addClass("hidden-c");
        }
      }
    });
  }
}

function swiper() {
  $(".variable-slider-sec .slider").each(function () {
    var _self = $(this);
    _self.append(_self.children().clone());
    _self.not(".slick-initialized").slick({
      slidesToScroll: 1,
      slidesToShow: 1,
      infinite: true,
      arrows: false,
      dots: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      focusOnSelect: false,
      variableWidth: true,
      draggable: true,
      cssEase: "cubic-bezier(0.42, 0, 0.58, 1)",
      swipe: true,
      touchMove: true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            variableWidth: false,
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            variableWidth: false,
            slidesToShow: 1,
          },
        },
      ],
    });

    _self.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
      _self.find(".slick-current").removeClass("move");
      setTimeout(function () {
        _self.find(".slick-current").addClass("move");
      }, 600);
    });
    _self.find(".slick-current").addClass("move");

    // _self .on("click", ".slick-slide", function (e) {
    //   e.stopPropagation();
    //   var index = $(this).data("slick-index");
    //   if (_self.slick("slickCurrentSlide") !== index) {
    //     _self.slick("slickGoTo", index);
    //   }
    // });

    _self.find('.slider-item:not(".slick-cloned")').eq(0).addClass("active");

    let isDragging = false;
    let startPosX = 0;

    _self.on("mousedown", function (e) {
      isDragging = false;
      startPosX = e.pageX;
    });

    _self.on("mousemove", function (e) {
      if (Math.abs(e.pageX - startPosX) > 10) {
        isDragging = true;
      }
    });

    _self.on("mouseup", function (e) {
      if (!isDragging) {
        const target = $(e.target);
        const clickedItem = target.closest(".slider-item");

        if (clickedItem.length) {
          _self.find(".slider-item").removeClass("active");
          clickedItem.addClass("active");
          _self.slick("setPosition");
        }
      }
    });

    $(document).on("click", function (e) {
      if (!$(e.target).closest(".variable-slider-sec").length) {
        _self.find(".slider-item").removeClass("active");
      }
    });

    document.querySelector(".variable-slider-sec .slider").addEventListener("wheel", function (e) {
      if (e.deltaX !== 0) {
        e.preventDefault();
        if (e.deltaX > 20) {
          $(".variable-slider-sec .slider").slick("slickNext");
        } else if (e.deltaX < -20) {
          $(".variable-slider-sec .slider").slick("slickPrev");
        }
      }
    });
  });

  // $(".ingredient-heroes-slider .slider-content").each(function () {
  //   var _self = $(this);
  //   _self.not(".slick-initialized").slick({
  //     slidesToScroll: 3,
  //     slidesToShow: 3,
  //     infinite: false,
  //     arrows: false,
  //     dots: false,
  //     pauseOnHover: false,
  //     pauseOnFocus: false,
  //     focusOnSelect: false,
  //     variableWidth: true,
  //     responsive: [
  //       {
  //         breakpoint: 991,
  //         settings: {
  //           variableWidth: false,
  //           slidesToShow: 2, slidesToScroll: 2,
  //         },
  //       },
  //       {
  //         breakpoint: 768,
  //         settings: {
  //           variableWidth: false,
  //           slidesToShow: 1,slidesToScroll: 1,
  //         },
  //       },
  //     ],

  //   });

  //   // _self.find('.slider-item').hover(function () {
  //   //   $(this).siblings().find('.text-hidden').slideUp().siblings('.text-show').slideDown();
  //   //   $(this).find('.text-hidden').slideDown();
  //   //   $(this).find('.text-show').slideUp();
  //   // }
  //   // )

  //   if($(window).width() > 991) {
  //     _self.find(".slick-current").addClass("move");

  //   };
  //   _self.find('.slider-item:not(.slick-cloned)').eq(0).addClass('active')
  //   _self.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
  //     _self.find(".slick-current").removeClass("move");
  //     setTimeout(function () {
  //     if($(window).width() > 991) {
  //     _self.find(".slick-current").addClass("move");

  //   };

  //     }, 600);

  //   });

  //   // _self.find('.slider-item').click(function() {
  //   //   $(this).siblings().removeClass('active');
  //   //   $(this).addClass('active');
  //   // })

  //   let isDragging = false;
  //   let startPosX = 0;
  //   _self.on('mousedown', function(e) {
  //     isDragging = false;
  //     startPosX = e.pageX;
  //   });

  //   _self.on('mousemove', function(e) {
  //     if (Math.abs(e.pageX - startPosX) > 10) {
  //       isDragging = true;
  //     }
  //   });
  //   _self.on('mouseup', function(e) {
  //     if (!isDragging) {
  //       const target = $(e.target);
  //       const clickedItem = target.closest('.slider-item');
  //       if (clickedItem.length) {
  //         _self.find('.slider-item').removeClass('active');
  //         clickedItem.addClass('active');
  //         _self.slick('setPosition');
  //       }
  //     }
  //   });

  // });
  if ($(".ingredient-heroes-slider").length) {
    $(".ingredient-heroes-slider .slider-item").eq(0).addClass("active");
    $(".ingredient-heroes-slider.tummy-time .slider-item").addClass("active");

    const slider = document.querySelector(".ingredient-heroes-slider  .slider-content");
    let isPointerDown = false;
    let isDragging = false;
    let startX = 0;
    let scrollStart = 0;
    let lastX = 0;
    let velocity = 0;
    let rafId = null;

    slider.addEventListener("pointerdown", (e) => {
      isPointerDown = true;
      isDragging = false;
      slider.classList.add("dragging");
      startX = e.clientX;
      scrollStart = slider.scrollLeft;
      lastX = e.clientX;
      cancelMomentumScroll();
    });

    slider.addEventListener("pointermove", (e) => {
      if (!isPointerDown) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 5) isDragging = true;
      slider.scrollLeft = scrollStart - dx;
      velocity = e.clientX - lastX;
      lastX = e.clientX;
    });
    window.addEventListener("pointerup", () => {
      isPointerDown = false;
      slider.classList.remove("dragging");
      setTimeout(() => (isDragging = false), 0);
      startMomentumScroll();
    });

    slider.querySelectorAll(".slider-item").forEach((item) => {
      item.addEventListener("click", (e) => {
        console.log("isDragging:", isDragging);
        if (isDragging) return;
        if (document.querySelector(".ingredient-heroes-slider").classList.contains("tummy-time")) return;
        item.classList.add("active");
        item.parentElement.querySelectorAll(".slider-item").forEach((el) => {
          if (el !== item) el.classList.remove("active");
        });
      });
    });

    function startMomentumScroll() {
      cancelAnimationFrame(rafId);
      function step() {
        slider.scrollLeft -= velocity;
        velocity *= 0.95;
        if (Math.abs(velocity) > 0.5) {
          rafId = requestAnimationFrame(step);
        }
      }
      step();
    }
    function cancelMomentumScroll() {
      cancelAnimationFrame(rafId);
    }
  }

  if ($("#swiper3").length) {
    var swiper3 = new Swiper("#swiper3", {
      loop: true,
      loopAdditionalSlides: 0,
      speed: 500,
      grabCursor: true,
      slidesPerView: "1.8",
      touchEventsTarget: "container",
      // freeMode: true,
      mousewheel: {
        forceToAxis: true,
        thresholdDelta: 15,
        sensitivity: 0.8,
        eventsTarget: "container",
      },
      simulateTouch: true,
      touchRatio: 1,
      keyboard: {
        enabled: true,
      },
      on: {
        init: function () {
          document.querySelectorAll(".reviews-crads .swiper-slide").forEach((slide, index) => {
            let rotateAngle, marginTop, marginRight;
            if ((index + 1) % 5 === 0) {
              // &:nth-child(5n)
              rotateAngle = "10.2deg";
              marginTop = "45px";
              marginRight = "-52px";
            } else if ((index + 1) % 4 === 1) {
              // &:nth-child(n)
              rotateAngle = "-5.2deg";
              marginTop = "45px";
              marginRight = "-18px";
            } else if ((index + 1) % 4 === 2) {
              // &:nth-child(2n)
              rotateAngle = "1.98deg";
              marginRight = "-42px";
              marginTop = "4px";
            } else if ((index + 1) % 4 === 3) {
              // &:nth-child(3n)
              rotateAngle = "-1.55deg";
              marginTop = "98px";
              marginRight = "-76px";
            } else if ((index + 1) % 4 === 0) {
              // &:nth-child(4n)
              rotateAngle = "1.55deg";
              marginTop = "56px";
              marginRight = "-96px";
            }

            slide.style.setProperty("--rotate-angle", rotateAngle);
            if (marginTop) slide.style.setProperty("--margin-top", marginTop);
            if (marginRight) slide.style.setProperty("--margin-right", marginRight);
          });
        },
      },

      breakpoints: {
        1200: {
          slidesPerView: "3.33",
        },
        767: { slidesPerView: "1.8" },
        575: {
          slidesPerView: "1.5",
        },
      },
    });

    const swiperContainer = document.querySelector("#swiper3");
    let startX = 0;

    swiperContainer.addEventListener("touchstart", (e) => {
      startX = e.touches[0].clientX;
    });

    swiperContainer.addEventListener("touchmove", (e) => {
      const moveX = e.touches[0].clientX - startX;
      if (Math.abs(moveX) > 50) {
        if (moveX > 0) {
          swiper3.slidePrev();
        } else {
          swiper3.slideNext();
        }
        startX = e.touches[0].clientX;
      }
    });
  }
  if ($("#swiper2").length) {
    var swiper2 = new Swiper("#swiper2", {
      loop: true,
      loopAdditionalSlides: 0,
      slidesPerView: "1",
      // speed: 500,
      // autoplay: true,
      grabCursor: true,
      spaceBetween: 20,
      // freeMode: true,
      touchEventsTarget: "wrapper",

      mousewheel: {
        forceToAxis: true,
        thresholdDelta: 15,
        sensitivity: 0.8,
        eventsTarget: "container",
      },
      keyboard: {
        enabled: true,
      },
      simulateTouch: true,
      touchRatio: 0.6,

      breakpoints: {
        1200: {
          slidesPerView: "4",
          spaceBetween: 25,
        },
        991: {
          slidesPerView: "3",
          spaceBetween: 25,
        },
        768: {
          slidesPerView: "2",
          spaceBetween: 25,
        },
        575: { slidesPerView: "1", spaceBetween: 25 },
      },
    });

    // const swiperContainer_2 = document.querySelector('#swiper2');
    // let startX = 0;

    // swiperContainer_2.addEventListener('touchstart', (e) => {
    //     startX = e.touches[0].clientX;
    // });

    // swiperContainer_2.addEventListener('touchmove', (e) => {
    //     const moveX = e.touches[0].clientX - startX;
    //     if (Math.abs(moveX) > 50) {
    //         if (moveX > 0) {
    //           swiper2.slidePrev();
    //         } else {
    //           swiper2.slideNext();
    //         }
    //         startX = e.touches[0].clientX;
    //     }
    // });
  }

  if ($(".product__images").length > 0) {
    $(".gallerys-box").each(function (index) {
      var $galleryBox = $(this);
      var $smallItems = $galleryBox.find(".product__slider-nav .slider-content");
      var _self = $galleryBox.find(".product__slider-display .slider-content");
      const $dotsWrapper = _self.next(".slick-bottom").find(".slick-dots-wrapper");
      const slickLength = _self.find(".slider-item").length;

      var $largeImage = $(".product-images__show-large .images").eq(index);

      if (slickLength < 2) {
        _self.next(".slick-bottom").hide();
      }
      $smallItems.find(".slider-item").eq(0).addClass("active");
      $largeImage.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: _self,
        focusOnSelect: false,
        dots: true,
        prevArrow: `
    <button type="button" class="slick-prev">
      <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.3857 8.01318H1.38574M1.38574 8.01318L8.38574 15.0132M1.38574 8.01318L8.38574 1.01318" 
              stroke="#fff" stroke-width="1.5" stroke-linecap="round"/>
        <path d="M15.3857 8.01318H1.38574M1.38574 8.01318L8.38574 15.0132M1.38574 8.01318L8.38574 1.01318" 
              stroke="#fff" stroke-opacity="0.2" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
    </button>
  `,

        nextArrow: `
    <button type="button" class="slick-next">
      <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.30176 8.01318H15.3018M15.3018 8.01318L8.30176 1.01318M15.3018 8.01318L8.30176 15.0132" 
              stroke="#fff" stroke-width="1.5" stroke-linecap="round"/>
        <path d="M1.30176 8.01318H15.3018M15.3018 8.01318L8.30176 1.01318M15.3018 8.01318L8.30176 15.0132" 
              stroke="#fff" stroke-opacity="0.2" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
    </button>
  `,
      });

      if ($smallItems.children().length > 5) {
        $smallItems.not(".slick-initialized").slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          arrows: false,
          dots: false,
          vertical: true,
          verticalSwiping: true,
          asNavFor: _self.add($largeImage),
          responsive: [{ breakpoint: 991, settings: { vertical: false, slidesToShow: 3 } }],
        });

        _self.not(".slick-initialized").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          appendDots: $dotsWrapper,
          dots: slickLength > 1,
          arrows: false,
          asNavFor: $smallItems.add($largeImage),
        });
        customSlickArrow(_self);
        $smallItems.find(".slider-item").click(function () {
          var slideIndex = $(this).data("slick-index");
          $(this).addClass("active").siblings().removeClass("active");
          $largeImage.slick("slickGoTo", slideIndex);
        });
        _self.on("afterChange", function (event, slick, currentSlide) {
          var slideIndex = currentSlide;
          $smallItems.slick("slickGoTo", slideIndex);

          $galleryBox
            .find(".product__slider-nav .slider-item[data-slick-index=" + slideIndex + "]")
            .addClass("active")
            .siblings()
            .removeClass("active");
        });
      } else {
        _self.not(".slick-initialized").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          appendDots: $dotsWrapper,
          dots: slickLength > 1,
          asNavFor: $largeImage,
          arrows: false,
        });
        customSlickArrow(_self);
        $smallItems.find(".slider-item").click(function () {
          var slideIndex = $(this).index();
          _self.slick("slickGoTo", slideIndex);
          $(this).addClass("active").siblings().removeClass("active");
          $(this).addClass("active").siblings().removeClass("active");
          $largeImage.slick("slickGoTo", slideIndex);
        });

        _self.on("afterChange", function (event, slick, currentSlide) {
          $largeImage.slick("slickGoTo", currentSlide);

          setTimeout(() => {
            $galleryBox.find(".product__slider-nav .slider-item").removeClass("active").eq(currentSlide).addClass("active");
          }, 500);
        });
      }

      let isDragging = false;
      let startPosX = 0;
      let startPosY = 0;
      const threshold = 5;

      _self.off("mousedown touchstart mousemove touchmove click");

      _self
        .on("mousedown touchstart", function (e) {
          isDragging = false;
          startPosX = e.type.includes("touch") ? e.originalEvent.touches[0].clientX : e.clientX;
          startPosY = e.type.includes("touch") ? e.originalEvent.touches[0].clientY : e.clientY;
        })
        .on("mousemove touchmove", function (e) {
          if (!startPosX && !startPosY) return;

          const currentX = e.type.includes("touch") ? e.originalEvent.touches[0]?.clientX || e.originalEvent.changedTouches[0].clientX : e.clientX;

          const currentY = e.type.includes("touch") ? e.originalEvent.touches[0]?.clientY || e.originalEvent.changedTouches[0].clientY : e.clientY;

          if (Math.abs(currentX - startPosX) > threshold || Math.abs(currentY - startPosY) > threshold) {
            isDragging = true;
          }
        })
        .on("click", ".slider-item", function (e) {
          if (isDragging) {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }

          // Desktop: zoom handled by magnify.js – skip lightbox
          if ($(window).width() >= 992) return;

          e.stopPropagation();
          $(".product-images__show-large").addClass("active");

          const index = $(this).closest(".gallerys-box").index();
          $(".product-images__show-large .images").eq(index).addClass("active").siblings().removeClass("active");
        })
        .on("mouseup touchend", function () {
          setTimeout(() => {
            isDragging = false;
            startPosX = 0;
            startPosY = 0;
          }, 50);
        });
    });
  }
}
function customSlickArrow(_self, loop = true) {
  const $controlwrapper = _self.next(".slick-bottom");
  const slickLength = _self.find(".slider-item").length;
  if (slickLength > 1) {
    $controlwrapper.find(".slick-arrow").show();
  }
  $controlwrapper.find(".slick-prev").on("click", function () {
    _self.slick("slickPrev");
  });
  $controlwrapper.find(".slick-next").on("click", function () {
    _self.slick("slickNext");
  });

  if (!loop) {
    $controlwrapper.find(".slick-prev").addClass("slick-disabled");
    _self.addClass("unloop");
    _self.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
      const slideCount = slick.slideCount;
      if (nextSlide === 0) {
        $controlwrapper.find(".slick-prev").addClass("slick-disabled");
      } else {
        $controlwrapper.find(".slick-prev").removeClass("slick-disabled");
      }
      if (nextSlide === slideCount - 1) {
        $controlwrapper.find(".slick-next").addClass("slick-disabled");
      } else {
        $controlwrapper.find(".slick-next").removeClass("slick-disabled");
      }
    });
  }
}
function click() {
  $(".menu-item-has-children").append("<span class='icon-right d-block d-xl-none'> </span> ");
  // menu box
  $(".navbar-left > .menu > .menu-item-has-children").hover(
    function () {
      $(this).closest(".navbar ").addClass("is-active");
    },
    function () {
      $(this).closest(".navbar ").removeClass("is-active");
    }
  );

  $(".menu-box .content >.sub-menu > li:nth-child(2)").addClass("is-active");
  $(".menu-box .content >.sub-menu > li:nth-child(2) >.sub-menu").show();

  // burger
  $(".navbar-burger").click(function (e) {
    e.stopPropagation();
    $(this).toggleClass("active");
    $(".navbar-left").toggleClass("is-active");
    $("body, html").toggleClass("overflow_hidden");
    $(".navbar-wrapper").toggleClass("menu-open");
  });

  $(".navbar-left > .menu > .menu-item-has-children ").click(function () {
    if ($(window).width() < 1200) {
      $(this).find(".menu-box").addClass("is-active");
      $(this).closest(".menu").addClass("toggle");
    }
  });

  $(".header-burger").click(function (e) {
    e.stopPropagation();
    $(this).toggleClass("active");
    $(".menu-box").toggleClass("active");
    $("body,html").toggleClass("overflow_hidden");
  });
  $(".navbar-left .sub-menu > .menu-item-has-children ").click(function () {
    if ($(window).width() < 1200) {
      $(this).toggleClass("is-active").find(" >.sub-menu").stop().slideToggle();
      $(this).siblings().removeClass("is-active").find(">.sub-menu").slideUp();
    }
  });
  $(".back").click(function () {
    $(this).closest(".menu-box").removeClass("is-active");
    $(this).closest(".menu").removeClass("toggle");
  });
  // search box
  $(".modal__close-button ").click(function () {
    $(".search-modal").removeClass("active");
    $("body, html").removeClass("overflow_hidden");
  });
  $(".search-box .header__icon ").click(function () {
    $(".search-modal.modal__content ").addClass("active");
    $("body, html").addClass("overflow_hidden");
  });

  $(".product__slider-display .image--plus").click(function (e) {
    e.stopPropagation();

    // Desktop: zoom handled by magnify.js – skip lightbox
    if ($(window).width() >= 992) return;

    $(".product-images__show-large ").addClass("active");
    var index = $(this).closest(".gallerys-box ").index();
    $(".product-images__show-large .images").eq(index).addClass("active").siblings().removeClass("active");
  });
  $(".product__datails-accordion .accordion-item h3").click(function () {
    $(this).parent().toggleClass("active").find(".drop-box").stop().slideToggle();
    $(this).parent().siblings().removeClass("active").find(".drop-box").slideUp();
  });

  // Animate "What's Included" dropdown open/close (like accordion)
  $(".product__include-dropdown__summary").on("click", function (e) {
    e.preventDefault();
    var $details = $(this).closest(".product__include-dropdown");
    var $items = $details.find(".include-items");

    if ($details.attr("open") !== undefined) {
      // Close with slide animation
      $items.stop().slideUp(300, function () {
        $details.removeAttr("open");
      });
    } else {
      // Open with slide animation
      $details.attr("open", "");
      $items.hide().stop().slideDown(300);
    }
  });

  $(".faq-lists .list-title ").click(function () {
    if ($(this).siblings(".drop-box").length) {
      $(this).parent().toggleClass("active").find(".drop-box").stop().slideToggle(300);
      $(this).parent().siblings().removeClass("active").find(".drop-box").slideUp(300);
    }
  });

  // number of products
  $(".number-label").click(function () {
    var number = $(this).data("number");
    $(this).addClass("active").siblings().removeClass("active");
    // $(".product__datails-info .product-form__input .quantity__input").val(number);
    // var price = $(this).data("price");

    // var priceDiscount = price.split("$")[1];

    var priceStr = jQuery(".price-list .price-item.active").attr("data-price");

    var qty = jQuery(this).attr("data-number");
    var currencySymbol = priceStr.replace(/[0-9.,]/g, "").trim();
    var priceValue = parseFloat(priceStr.replace(/[^0-9.,]/g, "").replace(",", "."));
    var totalValue = priceValue * qty;
    var formattedTotal;

    if (priceStr.indexOf(",") > -1) {
      formattedTotal = currencySymbol + totalValue.toFixed(2).replace(".", ",");
    } else {
      formattedTotal = currencySymbol + totalValue.toFixed(2);
    }
    jQuery(".product__datails-info .my-price-box").text(formattedTotal);
    $(".product-form__input.product-form__quantity .quantity__input").val(qty);

    // $(".product__datails-info .price.price--large.price--on-sale.price--show-badge .price__sale .price-item--last").text(price);
    // $(".product__datails-info .price.price--large.price--on-sale.price--show-badge .price__sale .price-item--regular").text("$" + priceDiscount * 2);
    // $(".product__datails-info .price.price--large.price--show-badge .price__regular .price-item--regular").text(price);
    // $('.product__datails-info .buy-button-box').contents().filter(function() {
    //   return this.nodeType === 3 && $.trim(this.nodeValue) !== '';
    // }).each(function() {
    //   this.nodeValue = this.nodeValue.replace('', price );
    // });

    // var textNode = $('.product__datails-info .buy-button-box').contents().filter(function() {
    //   return this.nodeType === 3 && $.trim(this.nodeValue) !== '';
    // }).first()[0];

    // $(".product__datails-info .buy-button-box > span:not([class])").text(price + " — ");
    // if (textNode) {
    //   textNode.nodeValue = price + " —— "
    // }
  });

  //  quantity__input

  // $(".cart-lists .quantity__input").each(function () {
  //   const $input = $(this).find("input");
  //   $input.on("change", function () {
  //     const newVal = parseInt($input.val(), 10);
  //     const $span_2 = $(this).siblings("span:not([class])");
  //     $span_2.text(newVal > 1 ? "Kids" : "Kid");
  //   });
  // });

  // $(document).on("click", ".list__quantity .quantity__button", function () {
  //   const $input = $(this).siblings(".quantity__input").find("input");
  //   var showVal = parseInt($(this).siblings(".quantity__input").find(".input-val").text());

  //   if ($(this).hasClass("minus")) {
  //     showVal = Math.max(1, showVal - 1);
  //   } else {
  //     showVal++;
  //   }
  //   $(this).siblings(".quantity__input").find(".input-val").text(showVal);
  //   $input.val(showVal).change();
  //   const $span_2 = $input.siblings("span:not([class])");
  //   $span_2.text(showVal > 1 ? "Kids" : "Kid");
  // });

  //  cart Lists

  $(document).on("click", ".cart-lists .lists-title", function () {
    $(this).toggleClass("active");
    $(this).siblings().find(".lists").stop().slideToggle(300);
  });
  $(document).on("click", ".nav-content--box", function () {
    $(this).toggleClass("active");
    $(this).siblings().stop().slideToggle(300);
  });

 $('.first-time-pop-up  .first-pop-btn').click(function ()  {
          jQuery(".first-time-pop-up").removeClass("is-active");
 })

  selfBlur(jQuery);

  function selfBlur($) {
    $("body").on("click", function (e) {
      var _pop = $(".pop-up  .content");

      if (!_pop.is(e.target) && _pop.has(e.target).length === 0) {
        jQuery(".pop-up").fadeOut();
        $("html,body").removeClass("overflow-hidden");
      }

      var _largeImage = jQuery(".product-images__show-large .content");
      if (!_largeImage.is(e.target) && _largeImage.has(e.target).length === 0) {
        jQuery(".product-images__show-large").removeClass("active");
        jQuery(".product-images__show-large .images").removeClass("active");
      }

      var _firstTimeContainer = jQuery(".first-time-pop-up .first-time-container");
      if (!_firstTimeContainer.is(e.target) && _firstTimeContainer.has(e.target).length === 0) {
        jQuery(".first-time-pop-up").removeClass("is-active");
      }

      var _input = jQuery(".select-input");
      if (!_input.is(e.target) && _input.has(e.target).length === 0) {
        jQuery(".select-input").removeClass("active").siblings().slideUp(300);
      }

      var menu_content = $(".menu-box .content");
      if (!menu_content.is(e.target) && menu_content.has(e.target).length === 0) {
        jQuery(".menu-box").removeClass("active");
        $(".header-burger").removeClass("active");
        $("body, html").removeClass("overflow_hidden");
      }
    });
  }
}
function resizeWindow() {
  var wh = $(window).width() < 1200 ? window.visualViewport.height : jQuery(window).height();
  var topBarHeight = $(".header-top-bar").length ? $(".header-top-bar").innerHeight() : 1 ;

  var headerHeight = $("header .navigation").innerHeight() + topBarHeight;
  var windowHeight = $(window).height();
  $(".hero-banner").attr("style", "--banner-height: " + (windowHeight - topBarHeight) + "px");
  $("body").attr("style", "--topbar-height: " + (wh - topBarHeight) + "px");
  // $('body:not(.homePage)').attr('style', '--header-height: ' + headerHeight  + 'px');

  $("body:not(.innerPage) #MainContent ").css("padding-top", topBarHeight);
  $("body:not(.homePage) #MainContent").css("margin-top", headerHeight);
  $("body.main-page-content #MainContent").css("margin-top", headerHeight - topBarHeight);
  // $('body').attr('style', '--height: ' + wh + 'px');
}

function marquee() {

  Marquee3k.init({
    selector: "marquee3k", // define a custom classname
  });
}
function cardsGasp() {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
    return;
  }

  gsap.registerPlugin(ScrollTrigger);
  if (!$(".three-cols-card").length) return;

  const threeColsSection = document.querySelector(".cards-scroll");
  if (!threeColsSection) return;

  const firstCard = threeColsSection.querySelector(".card:first-child");
  const secCard = threeColsSection.querySelector(".card:nth-child(2)");
  const lastCard = threeColsSection.querySelector(".card:last-child");

  if (!firstCard || !secCard || !lastCard) return;

  const cleanup = () => {
    ScrollTrigger.getAll().forEach((trigger) => {
      if (trigger.vars && trigger.vars.id === "cardsScroll") {
        trigger.kill(true);
      }
    });
    gsap.set([firstCard, secCard, lastCard], {
      clearProps: "all",
      immediateRender: true,
    });
  };

  const initAnimation = () => {
    cleanup();

    if (window.innerWidth < 992) return;

    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: threeColsSection,
        start: "top top",
        end: "bottom+=1000",
        pin: true,
        scrub: 0.5,
        markers: false,
        invalidateOnRefresh: true,
        id: "cardsScroll",
        onRefresh: (self) => {
          if (threeColsSection.offsetHeight < 500) {
            self.disable();
            gsap.set([firstCard, secCard, lastCard], { clearProps: "all" });
          }
        },
      },
    });

    timeline
      .to(
        firstCard,
        {
          rotation: -6.02,
          xPercent: -100,
          y: 88,
          ease: "expo.out",
          overwrite: "auto",
        },
        0
      )
      .to(
        secCard,
        {
          rotation: -1.76,
          x: 5,
          y: 0,
          ease: "expo.out",
          overwrite: "auto",
        },
        0
      )
      .to(
        lastCard,
        {
          rotation: 3.96,
          xPercent: 100,
          y: 128,
          ease: "expo.out",
          overwrite: "auto",
        },
        0
      );
  };

  initAnimation();

  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      ScrollTrigger.refresh();
      initAnimation();
    }, 300);
  });

  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      ScrollTrigger.refresh();
    }
  });
}

if (document.readyState === "complete") {
  cardsGasp();
} else {
  window.addEventListener("load", cardsGasp);
}

function gasp() {
  if ($(".image-group-and-text").length > 0) {
    ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    const isLargeScreen = $(window).width() > 991;
    const immunityStart = isLargeScreen ? "-0% top" : "-30% top";
    const immunityEnd = isLargeScreen ? "20% top" : "10% top";
    const handStart = isLargeScreen ? "-30% top" : "-40% top";
    const handEnd = isLargeScreen ? "20% top" : "15% top";

    gsap.fromTo(
      ".image-group-and-text .immunity",
      { top: "12.115%" },
      {
        top: "46.95%",
        ease: "power1.out",
        scrollTrigger: {
          trigger: ".image-group-and-text .content",
          start: immunityStart,
          end: immunityEnd,
          scrub: 0.5,
          invalidateOnRefresh: true,
          onLeave: () => {
            $(".immunity").addClass("active");
          },
          onEnterBack: () => {
            $(".immunity").removeClass("active");
          },
        },
      }
    );

    gsap.fromTo(
      ".image-group-and-text .hand",
      { top: "61.8419%" },
      {
        top: "60%",
        ease: "power1.out",
        scrollTrigger: {
          trigger: ".image-group-and-text .content",
          start: handStart,
          end: handEnd,
          scrub: 0.5,
          invalidateOnRefresh: true,
        },
      }
    );
  }
  // gsap.registerPlugin(ScrollTrigger);
  if ($(".banner-animate").length > 0) {
    ScrollTrigger.matchMedia({
      "(min-width: 992px)": function () {
        ScrollTrigger.create({
          trigger: ".hero-banner",
          start: "top top",
          end: "bottom top",
          pin: true,
          scrub: 1,
          id: "bannerAnimation",
        });

        gsap.to(".banner-animate .image.adult", {
          transform: "rotate(-12.3deg) scale(1.22) translate(-12%, 13%)",
          scrollTrigger: {
            trigger: ".hero-banner",
            start: "top top",
            end: "bottom top",
            scrub: 1,
          },

          onComplete: function () {
            $(".hero-banner .content .btn").addClass("js-show");
          },
        });

        gsap.to(".banner-animate .image.child", {
          transform: "rotate(4.86deg) scale(1.26) translate(-8.8%, -12.9%)",
          scrollTrigger: {
            trigger: ".hero-banner",
            start: "top top",
            end: "bottom top",
            scrub: 1,
          },
        });

        gsap.to(".banner-animate .image.multi", {
          top: "50%",
          transform: "translateY(-50%)",
          scrollTrigger: {
            trigger: ".hero-banner",
            start: "top",
            end: "bottom top",
            scrub: 1,
          },
        });
      },
      "(max-width: 991px)": function () {
        ScrollTrigger.getAll().forEach((trigger) => {
          if (trigger.vars.id === "bannerAnimation") {
            trigger.kill();
          }
        });
      },
    });
  }

  if ($(window).width() < 991) {
    var loadTime = window.performance.timing.domContentLoadedEventEnd - window.performance.timing.navigationStart;
    setTimeout(() => {
      $(".banner-animate").addClass("is-active");
    }, loadTime);
  }
  $(window).resize(function () {
    var loadTime = window.performance.timing.domContentLoadedEventEnd - window.performance.timing.navigationStart;
    setTimeout(() => {
      $(".banner-animate").addClass("is-active");
    }, loadTime);
  });

  if ($(".contact-form").length) {
    var windowWidth = $(window).width();

    $(".scroll-clouds .img").each(function () {
      var $img = $(this);
      var imgWidth = $img.width();

      var initialPosition = $img.offset().left;
      var position = initialPosition;

      var speed = 1;

      function animate() {
        position += speed;

        if (position > windowWidth) {
          position = -imgWidth;
        }

        $img.css("transform", "translateX(" + (position - initialPosition) + "px)");
        requestAnimationFrame(animate);
      }

      animate();
    });
  }
}
function gaspMove() {
  const $eyes = $(".eye-left, .eye-right");
  const $body = $("body");
  $(window).on("load", function () {
    setTimeout(initEyes, 100);
  });
  function initEyes() {
    $eyes.each(function () {
      const $eye = $(this);
      const parent = $eye.closest(".image");

      const eyeWidth = $eye.width();
      const eyeHeight = $eye.height();
      const eyeHalfWidth = eyeWidth / 2;
      const eyeHalfHeight = eyeHeight / 2;
      const boundaryWidth = 1.455 * eyeHalfWidth;
      const boundaryHeight = 1.517 * eyeHalfHeight;

      const maxX = boundaryWidth - eyeHalfWidth;
      const maxY = boundaryHeight - eyeHalfHeight;

      gsap.set($eye, { x: 0, y: 0 });

      let lastTime = 0;
      const throttleDelay = 16;

      $body.on("mousemove", function (e) {
        const now = Date.now();
        if (now - lastTime < throttleDelay) return;
        lastTime = now;

        const parentOffset = parent.offset();
        const mouseX = e.pageX - parentOffset.left - parent.width() / 2;
        const mouseY = e.pageY - parentOffset.top - parent.height() / 2;

        const offsetX = (mouseX / boundaryWidth) * 2;
        const offsetY = (mouseY / boundaryHeight) * 2;

        let finalX = offsetX * maxX;
        let finalY = offsetY * maxY;

        const ellipseFactor = Math.pow(finalX / maxX, 2) + Math.pow(finalY / maxY, 2);
        if (ellipseFactor > 1) {
          const scaleFactor = 1 / Math.sqrt(ellipseFactor);
          finalX *= scaleFactor;
          finalY *= scaleFactor;
        }

        gsap.to($eye, {
          duration: 0.2,
          x: finalX,
          y: finalY,
          ease: "power3.out",
          overwrite: true,
        });
      });
    });
  }
}

function customParallx() {
  $(".image-group .image").each(function () {
    let $this = $(this);
    let sh = $(window).scrollTop();
    const parallax_h = $(this).offset().top;
    const parallax_y = ( parallax_h - sh ) / 8;
    const isSmallScreen = $(window).width() > 575;
    if (isSmallScreen) {
      $this.css("transform", "translateY(" + parallax_y + "px)");
    } else {
      $this.css("transform", "translateY(0px)");
    }
  });

  $(".faq-sec.mid-width,.text-content ,.instagram-feed").each(function () {
    // let $this = $(this);
    // let sh = $(window).scrollTop();
    // const parallax_h = $(this).offset().top;
    // const parallax_y = (sh - parallax_h) / 8;
    // const isSmallScreen = $(window).width() > 991;

    const sh = $(window).scrollTop();
    const windowHeight = $(window).height();
    const isSmallScreen = $(window).width() > 991;
    const $this = $(this);
    const elementTop = $this.offset().top;
    const elementHeight = $this.outerHeight();
    const scrollRatio = (sh - elementTop + windowHeight) / (windowHeight + elementHeight);

    const parallaxY = Math.max(0, Math.min(1, scrollRatio)) * 100 * 2;

    if (isSmallScreen) {
      $this.attr("style", "--transformY:" + parallaxY + "px");
    } else {
      $this.attr("style", "--transformY: 0px");
    }
  });




  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const $this = $(entry.target);
        if (entry.isIntersecting) {
          const sh = $(window).scrollTop();
          const wh = $(window).height();
          const elementOffsetTop = $this.offset().top;
          const parallax_y = (sh - elementOffsetTop + wh) / 12;
          $this.css("transform", "translateY(" + parallax_y + "px)");
        } else {
          $this.css("transform", "translateY(0px)");
        }
      });
    },
    { threshold: 0.1 }
  );

  // $(".insta-feed--title .btn").each(function () {
  //     observer.observe(this);
  // });
}
function lenisFun() {
  const lenis = new Lenis({
    duration: 1.2,
    direction: "vertical",
  });

  lenis.on("scroll", (e) => {});

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  window.lenis = lenis;

  jQuery(".scroll-down").click(function () {
    const headerHeight = jQuery("header").innerHeight();
    const parentHeight = jQuery(this).parents(".hero-banner").next().offset().top;
    lenis.scrollTo(parentHeight - headerHeight, { duration: 2.2 });
  });
  const fragment = window.location.hash;
  const result = fragment.substring(1);
  if (result == "contact_form") {
    setTimeout(() => {
      const headerHeight = jQuery("header .navbar-wrapper").innerHeight();
      const parentHeight = $("#contact_form").closest(".faq-contact").offset().top - headerHeight;

      lenis.scrollTo(parentHeight - headerHeight, { duration: 2.2 });
    }, 500);
  }
  let resizeTimeout;
  window.addEventListener("scroll", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      lenis.resize();
    }, 200);
  });

  window.addEventListener("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      lenis.resize();
    }, 200);
  });

  if ($("#ingredients-anchor").length) {
    $(".text-and-image  .btn").click(function () {
      const headerHeight = jQuery(".header ").innerHeight();
      const ingredientsAnchor = $("#ingredients-anchor").offset().top - headerHeight;
      lenis.scrollTo(ingredientsAnchor, { duration: 2.2 });
    });
  }
}

function contentScrollNav() {
  const $articleContent = $(".text-content");
  const $rightContent = $(".text-content").find(".text");
  const $nav = $articleContent.find(".nav-content ul");
  const $navItems = $articleContent.find(".nav-item");
  const $header = $("header");
  const headerHeight = $header.innerHeight();
  // $nav.attr('data-lenis-prevent','true');
  var scrollTop = $(window).scrollTop();
  $rightContent.find(">h2").each(function () {
    let html = $(this).html();
    const id = html.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
    $(this).attr("id", id);
    $nav.append(`<li class='nav-item'><a href='#${id}'>${html}</a></li>`);
  });

  $nav.on("click", "a", function () {
    const targetOffset = $(this.hash).offset().top;
    $("html, body").animate({ scrollTop: targetOffset - headerHeight + 1 }, 500);
    $(this).parent().addClass("active").siblings().removeClass("active");
  });

  $nav.find("li").eq(0).addClass("active");
  $nav.find("li").each(function () {
    const $this = $(this);
    const target = $(this).children("a").attr("href");
    const targetOffset = $(target).offset().top - headerHeight;
    const nextTarget = $this.next().children("a").attr("href");
    const nextTargetOffset = nextTarget ? $(nextTarget).offset().top - headerHeight : Infinity;
    if (scrollTop >= targetOffset && scrollTop < nextTargetOffset) {
      $this.addClass("active").siblings().removeClass("active");
    }
  });
  $(window).on("scroll", function () {
    var scrollTop = $(window).scrollTop();
    $nav.find("li").each(function () {
      const $this = $(this);
      const target = $(this).children("a").attr("href");
      const targetOffset = $(target).offset().top - headerHeight;
      const nextTarget = $this.next().children("a").attr("href");
      const nextTargetOffset = nextTarget ? $(nextTarget).offset().top - headerHeight : Infinity;
      if (scrollTop >= targetOffset && scrollTop < nextTargetOffset) {
        $this.addClass("active").siblings().removeClass("active");
      }
    });
  });
}
function bannerHeight() {
  var topBarHeight = $(".header-top-bar").length ? $(".header-top-bar").innerHeight() : 0;
  var windowHeight = $(window).height();

  $(".hero-banner").attr("style", "--banner-height: " + (windowHeight - topBarHeight) + "px");
}

function imageSwitchChange() {
  $('.image-switch .list-title ul button').on('click',function(){
    var index = $(this).parent().index();
    $('.image-switch .list-content .list').eq(index).fadeIn().css('display','flex');
    $('.image-switch .list-content .list').eq(index).siblings().hide();
    $(this).parent().addClass('active').siblings().removeClass('active');
  })
}

var $ = jQuery.noConflict();
jQuery(document).ready(function () {
  const $marquee = $(".marquee-sec.style-2");

  const $styleSource = $marquee.parent().next().find(".text-and-image");

  if ($styleSource.length) {
    const styleString = $styleSource.attr("style") || "";
    const bgColorMatch = styleString.match(/--bg-c\s*:\s*(#[0-9a-f]+|rgba?\([^)]+\))/i);
    if (bgColorMatch && bgColorMatch[1]) {
      $marquee[0].style.setProperty("--border-bg", bgColorMatch[1]);
    }
  }
  if ($(".nav-content").length || $("#recharge-customer-portal").length) {
    $("body,html").attr("data-lenis-prevent", true);
  }
  wowo();
  click();

  marquee();
  swiper();
  gaspMove();
  resizeWindow();
  cookie();
  scroll();
  gasp();
  customParallx();
  contentScrollNav();
  bannerHeight();
  imageSwitchChange();
  if ($(window).width() > 575) {
    lenisFun();
  }
  jQuery(window).scroll(function () {
    wowo();
    customParallx();
  });
  if ($(".contact-form").length || $(".faq-sec.mid-width").length) {
    $("html, body").addClass("contact-bg-hidden");
  }
(function () {
  let ticking = false;

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }

  function update() {
    const sh = $(window).scrollTop();
    const windowHeight = $(window).height();

    $("#insta-feed").each(function (index) {
      const $this = $(this);
      const elementTop = $this.offset().top;
      const elementHeight = $this.outerHeight();

      const start = elementTop + elementHeight - windowHeight; 
      const end = elementTop;

      const scrollRange = end - start;
      let progress = 0;
      if (scrollRange !== 0) {
        progress = (sh - start) / scrollRange;
      }
      progress = Math.min(Math.max(progress, 0), 1);

      let totalWidth = 0;
      $this.find(".instafeed-new-layout-item").each(function () {
        totalWidth += $(this).outerWidth(true);
      });

      const containerWidth = $this.width();
      const maxScrollX = totalWidth > containerWidth ? totalWidth - containerWidth + 200 : 0;

      const parallaxX = progress * maxScrollX;

      $this.css("--transformX", `-${parallaxX}px`);

      // console.log(`Element ${index}: progress=${progress}, parallaxX=${parallaxX}px`);
    });

    ticking = false;
  }

  $(window).on("scroll resize", onScroll);
  update();
})();






  const targetHash = "ContactForm";
  const hash = window.location.hash.substring(1);
  if (hash === targetHash) {
    window.scrollTo({
      top: 0,
      // behavior: 'smooth'
    });
  }

  let lastHeight = window.innerHeight;
  jQuery(window).resize(function () {
    gaspMove();
    bannerHeight();
     customParallx();
    if ($(window).width() > 575) {
      resizeWindow();
    } else {
      const currentHeight = window.innerHeight;
      if (Math.abs(currentHeight - lastHeight) > 100) {
        lastHeight = currentHeight;
        resizeWindow();
      }
    }
  });

  document.addEventListener('instafeedAppLoaded', function() {
    document.querySelector('.instafeed-new-layout-wrapper').addEventListener("touchmove",function(e) {
       e.stopPropagation();
    } )
});

  // Product promo card — show/hide with localStorage (reappears after 7 days)
  (function initPromoCards() {
    var STORAGE_KEY = 'koa_promo_card_dismissed';
    var SEVEN_DAYS = 7 * 24 * 60 * 60 * 1000;
    var dismissed = false;

    try {
      var timestamp = localStorage.getItem(STORAGE_KEY);
      if (timestamp) {
        dismissed = (Date.now() - parseInt(timestamp, 10)) < SEVEN_DAYS;
        if (!dismissed) localStorage.removeItem(STORAGE_KEY);
      }
    } catch(e) {}

    var cards = document.querySelectorAll('.product__promo-card');
    if (!dismissed && cards.length) {
      for (var i = 0; i < cards.length; i++) {
        cards[i].style.display = '';
      }
    }

    window.dismissPromoCard = function() {
      var cards = document.querySelectorAll('.product__promo-card');
      for (var i = 0; i < cards.length; i++) {
        cards[i].classList.add('is-dismissing');
      }
      try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch(e) {}
      setTimeout(function() {
        for (var i = 0; i < cards.length; i++) {
          cards[i].style.display = 'none';
        }
      }, 250);
    };
  })();
});
